module.exports = __webpack_public_path__ + "static/media/img8.e0e90ba4.jpg";